<template>
  <form-section :title="$t(title)" :description="$t(description)">
    <template slot="controls">
      <rest-form-item
        v-show="
          !columns.some(
            e =>
              e.attribute === 'user_id' ||
              e.attribute === 'customer_id' ||
              (e.attribute === 'email' && profileIdfybyEmail)
          )
        "
        prop="config.columns"
      />
    </template>

    <div v-for="error in errors" class="error">
      <el-alert
        :title="$t(error)"
        type="error"
        :closable="false"
        left
        show-icon
        style="margin-bottom: 10px"
      >
      </el-alert>
    </div>

    <el-table :data="columns" :stripe="true">
      <el-table-column :label="nameTitle || $t('Imports_Label_Column')">
        <template slot-scope="scope">
          <div>
            {{
              translate(
                columns[scope.$index][nameField] ||
                  columns[scope.$index]['name']
              )
            }}
          </div>
        </template>
      </el-table-column>
      <el-table-column v-if="nameField2 && nameTitle2" :label="nameTitle2">
        <template slot-scope="scope">
          <div>
            {{ columns[scope.$index][nameField2] }}
          </div>
        </template>
      </el-table-column>

      <el-table-column
        :label="$t('Imports_Label_Sample')"
        v-if="sampleColumnEnabled"
      >
        <template slot-scope="scope">
          <div v-if="translateSamples">
            {{ $t(columns[scope.$index].sample) }}
          </div>
          <div v-else>
            {{ columns[scope.$index].sample }}
          </div>
        </template>
      </el-table-column>
      <el-table-column :label="$t('Imports_Label_MapTo')">
        <template slot-scope="scope">
          <div v-if="columns[scope.$index].readOnly || false">
            {{ columns[scope.$index].attribute }}
          </div>
          <el-select
            class="map-to-select"
            v-model="columns[scope.$index].attribute"
            :id="columns[scope.$index].attribute + '--Input'"
            @change="addAttr($event, columns[scope.$index])"
            :placeholder="$t(placeholder)"
            filterable
            remote
            :remote-method="fetchAttributes ? fetchAttributesRemote : null"
            @visible-change="selectVisibleChange"
            v-else-if="!isFixed(columns[scope.$index][nameField])"
          >
            <el-option :value="null">
              {{ $t(placeholder) }}
            </el-option>
            <el-option-group
              v-if="groupedAttributes && groupedAttributes.length > 0"
              v-for="attrGroup in groupedAttributes"
              :label="attrGroup.groupName"
              :key="attrGroup.groupName"
            >
              <el-option
                v-for="(item, index) in attrGroup.attributes.filter(
                  opt => !dataIncludes(opt, columns[scope.$index])
                )"
                :key="index"
                :label="item"
                :value="item"
              />
            </el-option-group>
            <el-option-group
              v-if="standardAttributes && standardAttributes.length > 0"
              :label="$t('Imports_Text_SystemAttributes')"
            >
              <el-option
                v-for="(item, index) in standardAttributes.filter(
                  opt => !dataIncludes(opt, columns[scope.$index])
                )"
                :key="index"
                :label="item"
                :value="item"
              />
            </el-option-group>

            <el-option-group
              :label="$t('Imports_Text_CustomAttributes')"
              v-if="attributes.length > 0"
            >
              <el-option
                v-for="(item, index) in attributes.filter(
                  opt => !dataIncludes(opt.name, columns[scope.$index])
                )"
                :key="index"
                :label="item.name"
                :value="item.name"
              />
            </el-option-group>
            <template v-if="showPreferencesGroup">
              <el-option-group :label="$t('Imports_Text_Preferences')">
              </el-option-group>
              <el-option-group
                v-for="channel in preferences"
                :label="channel.label"
                :key="channel.key"
                v-if="channel.preferences !== undefined"
              >
                <el-option
                  v-for="preference in channel.preferences"
                  :key="channel.key + '.' + preference.name"
                  :label="preference.name + ' (' + channel.label + ')'"
                  :value="
                    'consent_preferences.' + channel.key + '.' + preference.name
                  "
                >
                  {{ preference.name }}
                </el-option>
              </el-option-group>
            </template>
            <el-option-group
              :label="$t('Imports_Text_Metadata')"
              key="metadata-grp"
              v-if="includeMetadata && metadataAttributes.length > 0"
            >
              <el-option
                v-for="item in metadataAttributes"
                :key="item"
                :label="item"
                :value="item"
              />
            </el-option-group>
          </el-select>
          <div v-else>
            <el-select
              v-model="columns[scope.$index].attribute"
              @change="addAttr($event, columns[scope.$index])"
            >
              <el-option
                :label="$t('Imports_Text_Import')"
                :value="fixedMappings[columns[scope.$index][nameField]]"
              />
              <el-option :label="$t(placeholder)" :value="null" />
              <el-option
                v-if="usedAttr.hasOwnProperty(columns[scope.$index][nameField])"
                :label="usedAttr[columns[scope.$index][nameField]]"
                :value="usedAttr[columns[scope.$index][nameField]]"
              />
            </el-select>
          </div>
          <p
            v-if="
              showError(
                columns[scope.$index].attribute,
                columns[scope.$index][nameField]
              ) && showUnrecognizedError
            "
            class="error-field"
          >
            {{ getErrorField(scope) }}
            {{ $t(unrecognizedErrorMessage) }}
          </p>
        </template>
      </el-table-column>
    </el-table>
  </form-section>
</template>

<script>
import FormSection from '@/common/components/form/FormSection'
import RestFormItem from '@/common/components/rest/RestFormItem'
import { projectEndpoint } from '@/core/helpers'
import RestApi from '@/core/services/RestApi'
import _ from 'lodash'

export default {
  name: 'DataMapper',
  components: { RestFormItem, FormSection },
  props: {
    title: {
      type: String,
      required: false,
      default: 'Imports_Title_DataMapping'
    },
    description: {
      type: String,
      required: false,
      default: 'Imports_Title_DataMapping_Description'
    },
    placeholder: {
      type: String,
      required: false,
      default: 'Imports_Text_DontImport'
    },
    columns: {
      type: Array,
      required: true
    },
    translations: {
      type: Object,
      required: false,
      default: () => {}
    },
    translateSamples: {
      type: Boolean,
      default: false
    },
    attributesProp: {
      type: Array,
      required: true
    },
    filterableAttributes: {
      type: Array,
      required: true
    },
    groupedFilterableAttributes: {
      type: Array,
      required: false
    },
    fixedMappings: {
      type: Object,
      required: false,
      default: () => {
        return {}
      }
    },
    fixedAttribute: {
      type: String,
      required: false
    },
    errors: {
      type: Array,
      required: false,
      default: () => []
    },
    nameField: {
      type: String,
      default: 'name'
    },
    nameTitle: {
      type: String
    },
    nameField2: {
      type: String
    },
    nameTitle2: {
      type: String
    },
    sampleColumnEnabled: {
      type: Boolean,
      default: true
    },
    mapByFqn: {
      type: Boolean,
      default: false
    },
    checkOnlyFilterable: {
      type: Boolean,
      default: true
    },
    showUnrecognizedError: {
      type: Boolean,
      default: true
    },
    unrecognizedErrorMessage: {
      type: String,
      required: false,
      default: 'Imports_Text_AttributeNotRecognized'
    },
    fetchAttributes: {
      type: Boolean,
      default: true
    },
    fetchPreferences: {
      type: Boolean,
      default: true
    },
    includeMetadata: {
      type: Boolean,
      default: false
    }
  },
  mounted() {
    this.attributes = this.attributesProp
    this.populateInitialData()
    if (this.fetchAttributes) {
      this.fetchAttributesRemote()
    }
    this.columns.forEach(col => {
      if (this.isFixed(col[this.nameField])) {
        if (
          this.fixedMappings[col[this.nameField]] !== col.attribute &&
          col.attribute !== null
        ) {
          if (col.attribute) {
            this.usedAttr[col[this.nameField]] = col.attribute
          }
        }
      }
    })
  },
  data() {
    return {
      data: this.mapByFqn ? {} : [],
      attributes: [],
      preferences: [],
      defaultCustomAttr: [],
      oldAttr: [],
      search: '',
      usedAttr: {}
    }
  },
  computed: {
    standardAttributes() {
      let filterableAttributes = this.filterableAttributes
      if (!this.$store.state.app.features.customerIdEnabled) {
        filterableAttributes = filterableAttributes.filter(
          item => item !== 'customer_id'
        )
      }
      if (this.search === '') {
        return filterableAttributes
      } else {
        return filterableAttributes.filter(e => e.includes(this.search))
      }
    },
    groupedAttributes() {
      if (!this.groupedFilterableAttributes) return null

      const groups = _.cloneDeep(this.groupedFilterableAttributes)

      groups.forEach(group => {
        group.attributes = group.attributes.filter(attr => {
          if (this.search && this.search !== '') {
            return attr.includes(this.search)
          } else {
            return true
          }
        })
      })

      return groups
    },
    profileIdfybyEmail() {
      return this.$store.state.app.features.profileIdfybyEmail
    },
    attributesEndpoint() {
      return projectEndpoint({
        method: 'get',
        url: `tags`
      })
    },
    preferencesEndpoint() {
      return projectEndpoint({
        method: 'get',
        url: `consent-preferences`
      })
    },
    showPreferencesGroup() {
      return (
        this.fetchPreferences &&
        this.preferences.length &&
        this.preferences
          .map(item => item.preferences)
          .some(item => item !== undefined)
      )
    },
    fixedMappingKeys() {
      return Object.keys(this.fixedMappings)
    },
    metadataAttributes() {
      let filterableMetadata = ['metadata']
      if (this.search === '') {
        return filterableMetadata
      } else {
        return filterableMetadata.filter(e => e.includes(this.search))
      }
    }
  },
  methods: {
    showError(attr, field) {
      return (
        attr === undefined &&
        !this.filterableAttributes.includes(field) &&
        !this.attributes.map(item => item.name).includes(field)
      )
    },
    isFixed(attribute) {
      return this.fixedMappingKeys.includes(attribute)
    },
    getErrorField(scope) {
      let toJoin = [this.columns[scope.$index][this.nameField]]
      if (this.nameField2) {
        toJoin.push(this.columns[scope.$index][this.nameField2])
      }
      return toJoin.join('.')
    },

    populateInitialData() {
      this.columns.forEach(column => {
        if (!column.hasOwnProperty('attribute') || column.attribute === null) {
          return
        }

        if (!this.isValidColumn(column)) {
          return
        }

        if (this.mapByFqn) {
          this.addDataByNamespace(column)
        } else if (!this.data.includes(column.attribute)) {
          this.data.push(column.attribute)
        }
      })
    },

    isValidColumn(column) {
      const isFilterable =
        this.checkOnlyFilterable &&
        !this.isFilterable(column['attribute'].toLowerCase())

      const isAttributeInGroups = this.isAttributeInGroups(
        column['attribute'].toLowerCase()
      )

      return isFilterable || isAttributeInGroups
    },

    isFilterable(attribute) {
      return (
        this.filterableAttributes.includes(attribute) ||
        this.attributes.some(attr => attr.name === attribute)
      )
    },

    isAttributeInGroups(attribute) {
      return (
        this.groupedFilterableAttributes &&
        this.groupedFilterableAttributes.some(group =>
          group.attributes.includes(attribute)
        )
      )
    },

    addDataByNamespace(column) {
      const fqnNamespace = column.fqn ? column.fqn.split('.')[0] : 'common'
      if (!this.data.hasOwnProperty(fqnNamespace)) {
        this.data[fqnNamespace] = []
      }
      this.data[fqnNamespace].push(column.attribute)
    },

    fetchAttr(attr) {
      return RestApi({
        ...this.attributesEndpoint,
        params: {
          title: attr
        }
      })
    },

    addAttr(attr, column) {
      let oldIndexAttr = null
      const fqnNamespace = column.fqn ? column.fqn.split('.')[0] : 'common'
      const data = _.cloneDeep(
        this.mapByFqn ? this.data[fqnNamespace] || [] : this.data
      )

      for (let i = 0; i < this.oldAttr.length; i++) {
        if (
          JSON.stringify(this.oldAttr[i]) !== JSON.stringify(this.columns[i])
        ) {
          oldIndexAttr = data.findIndex(e => e === this.oldAttr[i].attribute)
          if (this.columns[i].attribute !== undefined && oldIndexAttr > -1) {
            if (attr === null) {
              data.splice(oldIndexAttr, 1)
            } else {
              data[oldIndexAttr] = this.columns[i].attribute
            }
          }
        }
      }
      if (attr !== null) {
        let oldDataIndexAttr = data.findIndex(e => e === attr)
        if (oldDataIndexAttr < 0) {
          data.push(attr)
        }
      }

      if (this.mapByFqn) {
        this.data[fqnNamespace] = data
      } else {
        this.data = data
      }
    },

    selectVisibleChange(open) {
      if (open) {
        Object.assign(this.oldAttr, _.cloneDeep(this.columns))
      } else {
        this.attributes = this.defaultCustomAttr
        this.oldAttr = []
      }
      this.search = ''
    },

    fetchAttributesRemote(query) {
      this.search = query
      let params = { sort: 'title', attribute_profile: 1 }
      if (query !== null && query !== '') {
        params.title = query
      }
      RestApi({
        ...this.attributesEndpoint,
        params: params
      })
        .then(({ data }) => {
          if (this.defaultCustomAttr.length === 0) {
            this.defaultCustomAttr = data
          }
          this.attributes = data
        })
        .catch(error => {
          this.$message({
            message: error.message,
            type: 'error'
          })
        })

      if (this.fetchPreferences) {
        this.fetchPreferencesRemote(query)
      }
    },

    fetchPreferencesRemote(query) {
      let params = { sort: 'name' }
      if (query !== null && query !== '') {
        params.name = query
      }

      RestApi({
        ...this.preferencesEndpoint,
        params: params
      })
        .then(({ data }) => {
          this.preferences = data
        })
        .catch(error => {
          this.$message({
            message: error.message,
            type: 'error'
          })
        })
    },

    dataIncludes(attributeName, column) {
      if (attributeName === column.attribute) {
        return false
      }

      if (attributeName === this.fixedAttribute) {
        return false
      }

      const fqnNamespace = column.fqn ? column.fqn.split('.')[0] : 'common'
      const data = this.mapByFqn ? this.data[fqnNamespace] : this.data
      return (data || []).includes(attributeName)
    },

    translate(column) {
      if (
        this.translations &&
        this.translations.hasOwnProperty(column) &&
        this.translations[column]
      ) {
        return this.$t(this.translations[column])
      }
      return column
    }
  },
  watch: {
    data: {
      handler: function(value) {
        this.$emit('input', value)
      },
      deep: true
    },
    columns: {
      handler: function(value) {
        this.populateInitialData()
      },
      deep: true
    }
  }
}
</script>

<style scoped>
.map-to-select {
  width: fit-content !important;
}
</style>



// WEBPACK FOOTER //
// src/common/components/DataMapper.vue